import { styled, Text, useWindowDimensions, XStack, YStack } from "tamagui";
import { VictoryPie, VictoryTooltip, VictoryLabel } from "victory";
import { jsx, jsxs } from "react/jsx-runtime";
const LegendItemStyled = styled(YStack, {
  flexDirection: "row",
  marginHorizontal: 5,
  alignItems: "center"
});
const ColorBox = styled(YStack, {
  width: 10,
  height: 10,
  marginRight: 5,
  borderRadius: 100
});
const Legend = ({
  legendData
}) => {
  if (!legendData || legendData.length === 0) return null;
  return /* @__PURE__ */jsx(XStack, {
    marginVertical: 10,
    flexWrap: "wrap",
    children: legendData?.map(item => /* @__PURE__ */jsxs(LegendItemStyled, {
      children: [/* @__PURE__ */jsx(ColorBox, {
        style: {
          backgroundColor: item.fill
        }
      }), /* @__PURE__ */jsx(Text, {
        fontSize: 12,
        children: item.name
      })]
    }, item.name))
  });
};
const CustomLabel = props => {
  const {
    x,
    y,
    text,
    isWideScreen
  } = props;
  return /* @__PURE__ */jsxs("g", {
    children: [/* @__PURE__ */jsx("defs", {
      children: /* @__PURE__ */jsxs("filter", {
        id: "shadow",
        x: "-20%",
        y: "-20%",
        width: "200%",
        height: "200%",
        children: [/* @__PURE__ */jsx("feGaussianBlur", {
          in: "SourceAlpha",
          stdDeviation: "3"
        }), /* @__PURE__ */jsx("feOffset", {
          dx: 2,
          dy: 2,
          result: "offsetblur"
        }), /* @__PURE__ */jsx("feFlood", {
          floodColor: "rgba(0, 0, 0, 0.3)"
        }), /* @__PURE__ */jsx("feComposite", {
          in2: "offsetblur",
          operator: "in"
        }), /* @__PURE__ */jsxs("feMerge", {
          children: [/* @__PURE__ */jsx("feMergeNode", {}), /* @__PURE__ */jsx("feMergeNode", {
            in: "SourceGraphic"
          })]
        })]
      })
    }), text && /* @__PURE__ */jsx("circle", {
      cx: x,
      cy: y,
      r: isWideScreen ? 15 : 20,
      fill: "white",
      stroke: "rgba(0, 0, 0, 0.25)",
      strokeWidth: "0.5",
      filter: "url(#shadow)"
    }), /* @__PURE__ */jsx(VictoryLabel, {
      x,
      y,
      text,
      textAnchor: "middle",
      verticalAnchor: "middle",
      style: {
        fontSize: isWideScreen ? 8 : 10,
        fontWeight: "bold"
      }
    })]
  });
};
const DonutChart = ({
  legendData,
  data,
  colorScale = ["#4ECDC4", "#FF6B6B"]
}) => {
  const {
    width
  } = useWindowDimensions();
  const isWideScreen = width < 500;
  const chartWidth = isWideScreen ? 280 : 350;
  const chartHeight = isWideScreen ? 280 : 350;
  const dataWithLabels = data.map(datum => ({
    ...datum,
    label: datum.y >= 5 ? datum.label : null
    // Show label only if value >= 5
  }));
  const innerRadius = isWideScreen ? chartWidth / 4 : chartWidth / 3.5;
  const LabelComponent = props => {
    const {
      datum
    } = props;
    return datum?.y < 5 ? /* @__PURE__ */jsx(VictoryTooltip, {
      flyoutStyle: {
        fill: "white",
        stroke: "gray",
        strokeWidth: 0.5
      },
      flyoutPadding: {
        top: 5,
        bottom: 5,
        left: 10,
        right: 10
      },
      style: {
        fontSize: 10,
        fontWeight: "bold"
      }
    }) : /* @__PURE__ */jsx(CustomLabel, {
      ...props,
      isWideScreen
    });
  };
  return /* @__PURE__ */jsxs(YStack, {
    gap: 10,
    justifyContent: "center",
    maxWidth: chartHeight,
    maxHeight: chartHeight + 50,
    children: [legendData && /* @__PURE__ */jsx(Legend, {
      legendData
    }), /* @__PURE__ */jsx(VictoryPie, {
      data: dataWithLabels,
      innerRadius,
      width: chartWidth,
      height: chartHeight,
      colorScale,
      labels: ({
        datum
      }) => datum.label,
      labelRadius: innerRadius + chartWidth / 9,
      labelComponent: /* @__PURE__ */jsx(LabelComponent, {}),
      events: [{
        target: "data",
        eventHandlers: {
          onPressIn: () => ({
            mutation: ({
              datum
            }) => {
              if (datum.y < 5) {
                return {
                  active: true
                };
              }
              return null;
            }
          }),
          onPressOut: () => ({
            mutation: () => ({
              active: false
            })
            // Hide tooltip when tap ends
          })
        }
      }],
      padding: {
        top: 0,
        bottom: 10,
        left: 40,
        right: 40
      }
    })]
  });
};
export { DonutChart };
//# sourceMappingURL=DonutChart.mjs.map
